import { useState } from "react";
import "./style.sass";

export const UploadModal = ({ onClose, onSubmit }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleView = () => {
    if (!file) return;

    const fileURL = URL.createObjectURL(file);
    const newWindow = window.open(fileURL);

    newWindow.onload = () => {
      URL.revokeObjectURL(fileURL); // cleanup
    };
  };

  return (
    <section className="upload-overlay">
      <section className="upload-modal">
        {/* Header */}
        <section className="modal-header">
          <section className="header-left">
            <section className="file-icon">📄</section>
            <section>
              <h3>Upload Answer Sheet</h3>
              <p>Upload your handwritten or typed answers as PDF</p>
            </section>
          </section>
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </section>

        {/* Upload Area */}
        {!file ? (
          <section className="upload-area">
            <section className="upload-icon">☁️</section>
            <h4>Drop your PDF here or click to browse</h4>
            <p>Supported format: PDF only · Maximum file size: 10MB</p>

            <label className="select-btn">
              Select File
              <input
                type="file"
                accept="application/pdf"
                hidden
                onChange={handleFileChange}
              />
            </label>
          </section>
        ) : (
          <section className="uploaded-file">
            <section className="file-info">
              <span>📄 {file.name}</span>
              <span className="success-text">Uploaded successfully</span>
            </section>
            <section className="file-actions">
              <button className="view-btn" onClick={handleView}>
                View
              </button>
              <button className="delete-btn" onClick={() => setFile(null)}>
                Delete
              </button>
            </section>
          </section>
        )}

        {/* Info Cards */}
        <section className="info-cards">
          <section className="info-card blue">
            <h5>File Requirements</h5>
            <p>Ensure text is clear and legible for accurate OCR processing</p>
          </section>

          <section className="info-card yellow">
            <h5>Best Practices</h5>
            <p>Use high-resolution scans with good lighting and contrast</p>
          </section>
        </section>

        {/* Footer */}
        <section className="modal-footer">
          <button
            className="submit-answer-sheet-btn"
            disabled={!file || loading}
            onClick={() => onSubmit(file)}
          >
            {loading ? "Submitting..." : "Submit Answer Sheet"}
          </button>
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
        </section>
      </section>
    </section>
  );
};
